import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import MediaQuery from "react-responsive"

// Config
import BreakPointConfig from "components/Stacker/constants/breakpoints"
import PRConfig from "components/Stacker/config/ProductConfiguratorConfig"

// Utils
import { useEffect } from "react"
import { useI18nContext } from "i18n/i18n-react"

function Step2({
  setContainerHeight,
  metal,
  theme,
  configTypeValue,
  setDesignStep,
}) {
  const node = useRef()
  const { LL } = useI18nContext()

  useEffect(() => {
    const updateHeight = () => {
      const computedHeight = getComputedStyle(node.current).height
      setContainerHeight(computedHeight)
    }
    setContainerHeight(getComputedStyle(node.current).height)
    window.scrollTo(0, 0)
    window.addEventListener("resize", updateHeight)
    return () => window.removeEventListener("resize", updateHeight)
  }, [setContainerHeight])

  return (
    <div
      className={`config-step-content config-${metal}-step2 config-step-content__Step2`}
      ref={node}
    >
      <div className="container-fluid">
        <h2
          id="step-title"
          className="text-center config-step-content__step-title"
        >
          {LL.productConfig.selectDesignText()} <br />
          {LL.productConfig.selectDesign2Text()}
        </h2>
        <div className="row">
          {PRConfig.DESIGN_VALUES.map((designType) => (
            <div
              className="col-6 config-step-content__step-option hover-transition"
              key={designType}
            >
              <div className="config-step-content__img-container step-bg-img">
                <MediaQuery query={BreakPointConfig.IS_MOBILE}>
                  <img
                    className="img-fluid"
                    src={`https://img.davidyurman.com/is/image/DavidYurmanNew/${configTypeValue}-${theme}-step2-${metal}-${designType}-mobile?$productConfigStep_mobile$`}
                    alt=""
                  />
                </MediaQuery>
                <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
                  <img
                    className="img-fluid"
                    src={`https://img.davidyurman.com/is/image/DavidYurmanNew/${configTypeValue}-${theme}-step2-${metal}-${designType}?$productConfigStep_desktop$`}
                    alt=""
                  />
                </MediaQuery>
              </div>
              <div
                className={`d-flex config-step-content__step-link config-step-content__step-link-${designType}`}
              >
                <div className="step-link-container">
                  <h6>{designType}</h6>
                </div>
              </div>
              <button
                className={`${designType}-btn`}
                value={designType}
                onClick={setDesignStep}
              >
                {designType}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

Step2.propTypes = {
  setDesignStep: PropTypes.func.isRequired,
  metal: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  setContainerHeight: PropTypes.func.isRequired,
  configTypeValue: PropTypes.string,
}

export default Step2
